import { UserOutlined } from '@ant-design/icons';
import {
    Avatar,
    Button,
    Descriptions,
    Divider,
    Drawer,
    Layout,
    List,
    Space,
    message,
} from 'antd';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../assets/Screenshot_2025-06-12_150614-removebg-preview.png';
import { logoutService } from '../service/api/loginService';
import { getStoreLocal } from '../utils/localStore';

const API_URL = process.env.REACT_APP_API_URL;
const { Header: AntHeader } = Layout;

const Header = ({ onAccountChange, onClearVideos }) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [accountWeb, setAccountWeb] = useState(null);
    const [runwayAccounts, setRunwayAccounts] = useState([]);
    const [minimaxAccounts, setMinimaxAccounts] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();

    const fetchAccounts = async (ownerId) => {
        try {
            const res = await axios.get(`${API_URL}/accounts/owner/${ownerId}`);
            const allAccounts = res.data || [];
            setRunwayAccounts(
                allAccounts.filter((acc) => acc.provider === 'runway'),
            );
            setMinimaxAccounts(
                allAccounts.filter((acc) => acc.provider === 'hailuo'),
            );
        } catch (err) {
            message.error('Không thể tải tài khoản AI từ server');
        }
    };

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('account_web') || 'null');
        setAccountWeb(user);

        if (user?.id) {
            fetchAccounts(user.id);
        }
    }, []);

    const handleOpenDrawer = () => {
        setIsDrawerOpen(true);
        if (accountWeb?.id) {
            fetchAccounts(accountWeb.id);
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('account_web');
        setAccountWeb(null);
        setRunwayAccounts([]);
        setMinimaxAccounts([]);
        setIsDrawerOpen(false);
        async function clearLocalStorage() {
            try {
                const res = await logoutService({
                    refreshToken: getStoreLocal('refresh_token'),
                });
                if (res?.status === 200) {
                    message.success('Đăng xuất thành công');
                    navigate('/login');
                }
                if (onAccountChange) onAccountChange();
                if (typeof onClearVideos === 'function') onClearVideos();
            } catch (error) {
                message.error(
                    'Đăng xuất không thành công, vui lòng thử lại sau',
                );
            }
        }
        clearLocalStorage();
    };

    const isAdmin = accountWeb?.role === 0;
    const isAdminPage = location.pathname === '/admin';

    return (
        <>
            <AntHeader
                style={{
                    background: '#fff',
                    padding: '0 40px',
                    height: '100px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                }}
            >
                <img
                    src={logo}
                    alt="Logo"
                    style={{ width: 180, height: 'auto' }}
                />

                <Space>
                    {isAdmin && !isAdminPage && (
                        <Button
                            type="default"
                            onClick={() => navigate('/admin')}
                        >
                            Quản trị
                        </Button>
                    )}

                    {accountWeb ? (
                        <Space
                            onClick={handleOpenDrawer}
                            style={{ cursor: 'pointer' }}
                        >
                            <Avatar icon={<UserOutlined />} />
                            <span>{accountWeb.username}</span>
                        </Space>
                    ) : (
                        <Button
                            type="primary"
                            onClick={() => navigate('/login')}
                        >
                            Đăng nhập / Đăng ký
                        </Button>
                    )}
                </Space>
            </AntHeader>

            <Drawer
                title="Thông tin tài khoản"
                placement="right"
                onClose={() => setIsDrawerOpen(false)}
                open={isDrawerOpen}
                width={440}
            >
                {accountWeb && (
                    <>
                        <Descriptions column={1} bordered size="small">
                            <Descriptions.Item label="Username">
                                {accountWeb.username}
                            </Descriptions.Item>
                            <Descriptions.Item label="Email">
                                {accountWeb.email}
                            </Descriptions.Item>
                            {accountWeb?.role === 0 && (
                                <Descriptions.Item label="Quyền">
                                    Admin
                                </Descriptions.Item>
                            )}
                        </Descriptions>
                    </>
                )}

                <Divider style={{ marginTop: 24 }}>Runway AI</Divider>
                <List
                    bordered
                    dataSource={runwayAccounts}
                    locale={{ emptyText: 'Không có tài khoản Runway AI' }}
                    renderItem={(item) => (
                        <List.Item>
                            <Space
                                direction="vertical"
                                style={{ width: '100%' }}
                            >
                                <Space>
                                    <Avatar icon={<UserOutlined />} />
                                    {item.email}
                                </Space>
                            </Space>
                        </List.Item>
                    )}
                />

                <Divider>Hailuo AI</Divider>
                <List
                    bordered
                    dataSource={minimaxAccounts}
                    locale={{ emptyText: 'Không có tài khoản Hailuo AI' }}
                    renderItem={(item) => {
                        const displayName =
                            item.name || item.accountId || 'Chưa rõ';
                        return (
                            <List.Item>
                                <Space
                                    direction="vertical"
                                    style={{ width: '100%' }}
                                >
                                    <Space>
                                        <Avatar icon={<UserOutlined />} />
                                        {displayName}
                                    </Space>
                                </Space>
                            </List.Item>
                        );
                    }}
                />

                <Divider />

                <Button danger onClick={handleLogout} block>
                    Đăng xuất
                </Button>
            </Drawer>
        </>
    );
};

export default Header;
